var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroductionLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 840,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 840,
    height: 1024,
    fill: "#ad9b89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0c0000",
    fillOpacity: 0.501961,
    points: "180,271 96,21 30,251"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "-6,-16 -2,109 225,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "101,-16 225,-1 204,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#95531f",
    fillOpacity: 0.501961,
    points: "111,3 11,175 194,175"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "-7,-14 129,-16 -1,159"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "184,214 79,271 40,164"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "205,-16 123,153 225,136"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "195,271 225,172 166,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#703713",
    fillOpacity: 0.501961,
    points: "143,43 85,27 185,183"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e4aa74",
    fillOpacity: 0.501961,
    points: "60,159 172,128 56,79"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fce6d1",
    fillOpacity: 0.501961,
    points: "-6,77 -16,251 49,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#231e0e",
    fillOpacity: 0.501961,
    points: "225,142 84,152 85,192"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0a0000",
    fillOpacity: 0.501961,
    points: "106,109 105,22 71,71"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "98,8 225,119 207,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "122,185 171,187 158,160"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9f5b20",
    fillOpacity: 0.501961,
    points: "53,239 97,87 6,123"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "173,271 38,232 104,197"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "-16,131 11,-16 67,96"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fbfffc",
    fillOpacity: 0.501961,
    points: "189,178 212,237 164,268"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "153,150 119,124 156,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2d0800",
    fillOpacity: 0.501961,
    points: "152,117 127,113 141,51"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bf835c",
    fillOpacity: 0.501961,
    points: "122,125 90,-16 136,64"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "129,37 109,23 85,39"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "225,138 143,74 175,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#af692d",
    fillOpacity: 0.501961,
    points: "51,218 109,170 134,184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "84,92 82,76 60,95"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "101,15 35,113 56,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#213335",
    fillOpacity: 0.501961,
    points: "154,271 178,212 120,177"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4c240c",
    fillOpacity: 0.501961,
    points: "155,160 175,177 225,168"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#190900",
    fillOpacity: 0.501961,
    points: "203,141 153,157 207,155"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "60,126 85,132 72,123"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7ffff",
    fillOpacity: 0.501961,
    points: "87,125 121,123 93,115"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bf7a39",
    fillOpacity: 0.501961,
    points: "73,209 24,167 32,236"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "98,16 219,79 201,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4f2604",
    fillOpacity: 0.501961,
    points: "82,56 116,58 47,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b86613",
    fillOpacity: 0.501961,
    points: "123,128 38,136 132,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2e1304",
    fillOpacity: 0.501961,
    points: "66,205 29,139 94,192"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000200",
    fillOpacity: 0.501961,
    points: "206,271 17,271 123,230"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5b390",
    fillOpacity: 0.501961,
    points: "137,60 116,39 129,84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cbc175",
    fillOpacity: 0.501961,
    points: "181,179 157,183 184,225"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#170800",
    fillOpacity: 0.501961,
    points: "103,186 67,201 94,146"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0ad8e",
    fillOpacity: 0.501961,
    points: "31,163 31,227 2,123"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e9e8e7",
    fillOpacity: 0.501961,
    points: "127,183 160,161 161,188"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7b391",
    fillOpacity: 0.501961,
    points: "69,144 86,166 41,134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#421c00",
    fillOpacity: 0.501961,
    points: "140,65 147,50 125,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b36228",
    fillOpacity: 0.501961,
    points: "167,103 158,149 152,82"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#281a11",
    fillOpacity: 0.501961,
    points: "85,132 89,118 65,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#271809",
    fillOpacity: 0.501961,
    points: "111,27 88,101 86,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#aec1d7",
    fillOpacity: 0.501961,
    points: "66,242 43,250 68,249"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0ecf1",
    fillOpacity: 0.501961,
    points: "155,147 125,152 153,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#333c3b",
    fillOpacity: 0.501961,
    points: "159,188 105,191 174,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fbe1ae",
    fillOpacity: 0.501961,
    points: "225,137 158,99 171,146"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "50,105 -5,120 30,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c2becd",
    fillOpacity: 0.501961,
    points: "128,197 109,179 126,187"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffff0",
    fillOpacity: 0.501961,
    points: "178,178 188,205 225,172"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#945314",
    fillOpacity: 0.501961,
    points: "45,218 49,151 28,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c98451",
    fillOpacity: 0.501961,
    points: "64,96 132,100 22,125"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#171e1a",
    fillOpacity: 0.501961,
    points: "170,159 81,171 126,152"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#060603",
    fillOpacity: 0.501961,
    points: "152,189 148,215 124,184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fae8d7",
    fillOpacity: 0.501961,
    points: "198,163 169,161 198,155"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "-16,124 82,56 98,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a79f7c",
    fillOpacity: 0.501961,
    points: "93,19 104,-16 105,25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ac602b",
    fillOpacity: 0.501961,
    points: "130,124 146,119 105,70"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#030804",
    fillOpacity: 0.501961,
    points: "106,271 44,228 108,193"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cf7d31",
    fillOpacity: 0.501961,
    points: "118,167 81,206 112,188"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b8622d",
    fillOpacity: 0.501961,
    points: "225,191 199,156 206,139"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a79583",
    fillOpacity: 0.501961,
    points: "48,254 26,271 32,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0fef6",
    fillOpacity: 0.501961,
    points: "175,222 169,245 225,241"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "178,121 225,5 120,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "65,95 61,84 38,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "122,179 126,170 139,175"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ebe8bf",
    fillOpacity: 0.501961,
    points: "157,188 167,206 186,195"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4e585a",
    fillOpacity: 0.501961,
    points: "171,244 170,216 132,210"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5d6c8",
    fillOpacity: 0.501961,
    points: "22,228 7,114 -16,221"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a86623",
    fillOpacity: 0.501961,
    points: "78,153 115,124 130,155"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2c1300",
    fillOpacity: 0.501961,
    points: "146,66 132,83 141,111"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d5cfd3",
    fillOpacity: 0.501961,
    points: "126,131 132,153 150,118"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ae6942",
    fillOpacity: 0.501961,
    points: "72,162 64,146 57,193"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#261508",
    fillOpacity: 0.501961,
    points: "117,89 96,73 80,97"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "105,21 113,-15 225,55"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0f1913",
    fillOpacity: 0.501961,
    points: "52,155 47,188 58,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4d290e",
    fillOpacity: 0.501961,
    points: "126,56 142,49 122,49"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ad7840",
    fillOpacity: 0.501961,
    points: "82,180 91,184 99,178"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b06c3b",
    fillOpacity: 0.501961,
    points: "166,105 168,151 141,85"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#68553f",
    fillOpacity: 0.501961,
    points: "82,61 106,23 89,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4d4b47",
    fillOpacity: 0.501961,
    points: "63,232 31,247 63,242"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bc8652",
    fillOpacity: 0.501961,
    points: "83,54 79,65 65,72"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2d2d20",
    fillOpacity: 0.501961,
    points: "116,155 192,144 161,162"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "95,20 47,-11 62,79"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a56521",
    fillOpacity: 0.501961,
    points: "44,202 47,226 85,202"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#97572e",
    fillOpacity: 0.501961,
    points: "100,64 106,43 115,96"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9b8a9",
    fillOpacity: 0.501961,
    points: "138,165 166,161 142,173"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdb887",
    fillOpacity: 0.501961,
    points: "127,45 111,54 112,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8c5d3c",
    fillOpacity: 0.501961,
    points: "214,167 172,170 166,157"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#421f02",
    fillOpacity: 0.501961,
    points: "156,111 148,118 131,83"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c1916a",
    fillOpacity: 0.501961,
    points: "49,97 59,88 37,97"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5dccf",
    fillOpacity: 0.501961,
    points: "85,91 85,82 61,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#caa281",
    fillOpacity: 0.501961,
    points: "-4,129 19,146 32,111"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0f0900",
    fillOpacity: 0.501961,
    points: "78,150 95,178 101,155"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c4cabd",
    fillOpacity: 0.501961,
    points: "48,-7 30,-16 50,45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionLow);
export default __webpack_public_path__ + "static/media/introduction_low.f0014e2ea74a4a4732bab6da74330715.svg";
export { ForwardRef as ReactComponent };